import { Type, type SchemaOptions } from '@sinclair/typebox';
import { validateEnumTranslations } from '../../safety_checks';
import { ProNewsStatus } from '../namespace';

export const PRO_NEWS_STATUS_TRANSLATE_KEY = 'PRO_NEWS_STATUS_';

export const ProNewsStatusTranslation = {
  'fr-FR': {
    [`${PRO_NEWS_STATUS_TRANSLATE_KEY}${ProNewsStatus.TO_REVIEW}`]: 'À valider',
    [`${PRO_NEWS_STATUS_TRANSLATE_KEY}${ProNewsStatus.DRAFT}`]: 'Brouillon',
    [`${PRO_NEWS_STATUS_TRANSLATE_KEY}${ProNewsStatus.SCHEDULED}`]: 'Planifiée',
    [`${PRO_NEWS_STATUS_TRANSLATE_KEY}${ProNewsStatus.PUBLISHED}`]: 'Publiée',
    [`${PRO_NEWS_STATUS_TRANSLATE_KEY}${ProNewsStatus.ARCHIVED}`]: 'Archivée',
  },
};

validateEnumTranslations(ProNewsStatus, ProNewsStatusTranslation, PRO_NEWS_STATUS_TRANSLATE_KEY, true);

export const ProNewsStatusSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(ProNewsStatus).map((value) =>
      Type.Literal(value, {
        label: `${PRO_NEWS_STATUS_TRANSLATE_KEY}${value}`,
      }),
    ),
    options,
  );
};
